import { render, staticRenderFns } from "./ChooseTraderButton.vue?vue&type=template&id=73cfa62c&scoped=true&"
import script from "./ChooseTraderButton.vue?vue&type=script&lang=js&"
export * from "./ChooseTraderButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73cfa62c",
  null
  
)

export default component.exports